import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";

export const commerceApi = createApi({
    reducerPath: 'commerceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: '/commerce/api',
    }),
    tagTypes: ['commerce'],
    endpoints: (build) => ({
        selectPresentBenefit: build.mutation({
            query: (data) => ({
                url: '/coupons/free/select-present-benefit',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getUserUsedPaidCoupons: build.mutation({
            query: (data) => ({
                url: '/coupons/paid/get-user-used-paid-coupons',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getUserCouponsForBenefit: build.mutation({
            query: (data) => ({
                url: '/coupons/getUserCouponsForBenefit',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getUserUsedDownloadedCoupons: build.mutation({
            query: (data) => ({
                url: '/coupons/free/get-user-used-coupons',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        changeFreeCouponArchiveStatus: build.mutation({
            query: (data) => ({
                url: '/coupons/free/change-coupon-archive-status',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })      
        }),
        changePaidCouponArchiveStatus: build.mutation({
            query: (data) => ({
                url: '/coupons/paid/change-coupon-archive-status',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        cancelPaidCoupons: build.mutation({
            query: (data) => ({
                url: '/coupons/paid/cancel',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        })
    })
})

export const {
    useSelectPresentBenefitMutation,
    useGetUserUsedPaidCouponsMutation,
    useGetUserUsedDownloadedCouponsMutation,
    useChangeFreeCouponArchiveStatusMutation,
    useChangePaidCouponArchiveStatusMutation,
    useCancelPaidCouponsMutation,
    useGetUserCouponsForBenefitMutation,
} = commerceApi;